module.exports = __webpack_public_path__ + "static/media/winter.82dde537.jpg";